// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__-9eVi","header":"Projects_header__P1fCw","projectsContainer":"Projects_projectsContainer__xbR3t"};